import { Controller } from "@hotwired/stimulus"
import { TurboBeforeFetchRequestEvent } from "@hotwired/turbo"
import Confirmation from "../../confirmation"

export default class ShowController extends Controller {
  async confirmArchive(event: TurboBeforeFetchRequestEvent) {
    event.preventDefault()

    if (await Confirmation.confirmArchive("this response")) {
      event.detail.resume(null)
    }
  }
}
